import React, { useState, useEffect } from "react";
import { useCurrentPolicyContext } from "../../actions/CurrentPolicyContext";
import { useLoadingContext } from "../../Loading/LoadingContext";
import { getSingleData } from "../../Utils/CallApiUtils";
import { convertDateFormatWithOutTime } from "../../Utils/commonFunction";
import UserSetting from "../../UserSettings.json";
import DetailCard, { formatINR } from "../../Common/DetailCard";
import EmptyState from "../../Common/EmptyState";
import "../Courier/DetailSheet.css";

export default function Endorsement() {
  const { currentSelectPolicyID, currentSelectPolicyNo } =
    useCurrentPolicyContext();
  const [endorsementData, setEndorsementData] = useState([]);
  const { setIsLoading } = useLoadingContext();

  useEffect(() => {
    if (currentSelectPolicyID > 0) {
      getEndorsementDetail();
    } else {
      window.location = "/";
    }
  }, [currentSelectPolicyID]);

  const getEndorsementDetail = async () => {
    await getSingleData(
      `Endorsement/AllEndorsementDataDetailModel?PolicyID=${currentSelectPolicyID}`,
      setEndorsementData,
      setIsLoading
    );
  };

  if (endorsementData.length === 0) {
    return (
      <EmptyState
        icon="fa-file-pen"
        title="No endorsements on this policy"
        text="An endorsement is a change made to a policy after it was issued. Any change will be listed here with its date and cost."
        meta={currentSelectPolicyNo && `Policy Number : ${currentSelectPolicyNo}`}
      />
    );
  }

  return (
    <div className="sheet">
      {endorsementData.map((item, index) => (
        <DetailCard
          key={item.endorsementID || index}
          eyebrow="Endorsement For"
          /* What changed leads, not the policy number — the customer already
             knows which policy they opened. */
          title={item.endorsementName}
          meta={`Policy Number : ${item.policyNo || currentSelectPolicyNo || "—"}`}
          chip={
            item.endorsementDate &&
            convertDateFormatWithOutTime(item.endorsementDate)
          }
          chipTone="neutral"
          facts={[
            { label: "Premium", value: formatINR(item.premiumAmt) },
            {
              label: "Service tax",
              value:
                item.serviceTaxAmount !== null &&
                item.serviceTaxAmount !== undefined
                  ? `${formatINR(item.serviceTaxAmount)}${
                      item.serviceTax ? ` (${item.serviceTax}%)` : ""
                    }`
                  : null,
            },
            { label: "Net amount", value: formatINR(item.netAmount), amount: true },
          ]}
          documentHref={item.imagePath && UserSetting.imgURL + item.imagePath}
          documentLabel="Endorsement document"
        />
      ))}
    </div>
  );
}
